import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { createWorkspace } from '../../../api/workspaces';

export function useCreateWorkspace() {
  const queryClient = useQueryClient();

  return useMutation(createWorkspace, {
    onSettled: () => {
      return queryClient.invalidateQueries(workspaceKeys.all);
    },
  });
}
